var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.rolesConfig),function(ref,index){
var role = ref.role;
var roleName = ref.roleName;
var classes = ref.classes;
return [(index !== 0)?_c('div',{key:'spacer' + role,staticClass:"ml-4 mb-4"}):_vm._e(),_c('v-chip',{key:role,staticClass:"selectable caption justify-center",class:classes,attrs:{"value":role},on:{"click":function($event){$event.stopPropagation();return _vm.onChange(role)}}},[_vm._v(" "+_vm._s(roleName.toUpperCase())+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }